import { atom } from "recoil";
import { ISupplyAlertProfile } from "../types";

export const addStateSupplyAlertProfile = atom({
  key: "addStateSupplyAlertProfile",
  default: false,
});
export const editStateSupplyAlertProfile = atom({
  key: "editStateSupplyAlertProfile",
  default: false,
});
export const rowEditSupplyAlertProfile = atom<ISupplyAlertProfile | undefined>({
  key: "rowEditSupplyAlertProfile",
  default: undefined,
});

export const selectedRowsStateSupplyAlertProfile = atom<ISupplyAlertProfile[]>({
  key: "selectedRowsStateSupplyAlertProfile",
  default: [],
});

export const supplyAlertProfileFilterText = atom({
  key: "SupplyAlertProfileFilterText",
  default: "",
});

export const savingSupplyAlertProfile = atom({
  key: "savingSupplyAlertProfile",
  default: false,
});
export const supplyAlertProfileFetching = atom({
  key: "SupplyAlertProfileFetching",
  default: true,
});
